import { cx } from '@linaria/core';
import { HttpStatus, textColumnCls, verticalPaddingCls } from '@pm2/react-utils';
import { Link } from '@provider/navigation';
import { headingCls, textCls, buttonWrapperCls, buttonCls } from './message.base.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const NotFound = () => {
  return /*#__PURE__*/jsxs("article", {
    className: cx("gPortal-page", textColumnCls, verticalPaddingCls),
    children: [/*#__PURE__*/jsx(HttpStatus, {
      code: 404
    }), /*#__PURE__*/jsx("h1", {
      className: headingCls,
      children: "Siden blev ikke fundet"
    }), /*#__PURE__*/jsxs("p", {
      className: textCls,
      children: ["Den p\xE5g\xE6ldende side blev desv\xE6rre ikke fundet.", /*#__PURE__*/jsx("br", {}), "Klik p\xE5 knappen nedenfor for at g\xE5 til forsiden."]
    }), /*#__PURE__*/jsx("div", {
      className: buttonWrapperCls,
      children: /*#__PURE__*/jsx(Link, {
        href: "/",
        className: buttonCls,
        children: "G\xE5 til forsiden"
      })
    })]
  });
};

export { NotFound };
//# sourceMappingURL=message.not-found.js.map
